<div class="live-chat" [ngClass]="{'modal-window': modalMode, 'mobile': deviceDetector.isMobile()}" [dir]="dir" *ngIf="chatList?.length > 0; else listEmpty;">
    <div class="side-nav" [ngClass]="{'active': showSideNav}">
        <div class="header" style="display: none;">
            <input type="text" class="search-input" [placeholder]="'search'|translate">
        </div>
        <ng-container *ngFor="let chat of chatList; index as i">
        <button type="button" class="chat-list-item" (click)="openChatWindow(i);">
            <div class="avatar" style="background-image: url('{{chat.companyData?.logo?.url}}');">
                <mat-icon *ngIf="!chat.companyData?.logo?.url" class="mat-icon-rtl-mirror">question_answer</mat-icon>
            </div>
            <div class="text">
                <div class="title">{{getChatTitle(chat)}}</div>
                <div class="caption">{{chat.message?.files?.length ? chat.message?.files?.length + ' Files uploaded' : chat.message?.msg}}</div>
            </div>
            <div class="meta">{{getMessageTime(chat.message?.timestamp)}}</div>
        </button>
        <div class="divider"></div>
        </ng-container>
    </div>
    <div class="side-nav-scrim" (click)="closeSideNav();"></div>

    <div class="chat-container">
        <div class="header">
            <button mat-icon-button type="button" class="nav-button" (click)="openSideNav();">
                <mat-icon class="mat-icon-rtl-mirror">menu</mat-icon>
            </button>
            <div class="title">{{chatWindow ? chatWindow.name : 'live_chat'|translate}}</div>
            <button mat-icon-button class="chat-close-button modal-close" type="button" (click)="bsModalRef?.hide();">
                <mat-icon>close</mat-icon>
            </button>
            <a mat-icon-button class="chat-close-button page-close" routerLink="/account/dashboard">
                <mat-icon>close</mat-icon>
            </a>
        </div>

        <div class="chat-content" #chatContent (scroll)="onScroll($event)">
        <ng-container *ngIf="chatWindow; else windowEmpty">
            <ng-container *ngFor="let message of chatWindow.messagesData">
            <div class="chat-date" *ngIf="message.dateOnly">{{ message.dateOnly }}</div>
            <div class="chat-group" *ngIf="!message.dateOnly"[ngClass]="{'send': message.sentFromUser, 'receive': !message.sentFromUser, 'head-message': message.head }">
                <ng-container *ngIf="message.files">
                    <ng-container *ngFor="let file of message.files;">
                        <ng-container *ngIf="isFileImage(file.mimetype); else generalFile">
                            <a class="chat-file" [href]="file.url" target="_blank" style="background-image: url('{{file.url}}');">
                            </a>
                        </ng-container>
                        <ng-template #generalFile>
                            <a class="chat-file" [href]="file.url" target="_blank">
                                <mat-icon [inline]="true" style="font-size: 3rem;">insert_drive_file</mat-icon>
                                <div class="file-name">{{file.filename}}</div>
                            </a>
                        </ng-template>
                    </ng-container>
                </ng-container>
                <div class="chat-bubble" *ngIf="message.msg">
                    <div class="sender-name" *ngIf="!message.sentFromUser && message.head">{{message.senderData.name}}</div>
                    {{message.msg}}
                    <div class="time">{{getMessageTime(message.timestamp)}}</div>
                </div>
            </div>
            </ng-container>
        </ng-container>
        <ng-template #windowEmpty>
            <div class="empty-state" style="margin: auto;">
                <img class="illustration" src="assets/images/empty_state_clouds.jpg">
            </div>
        </ng-template>
        </div>
        <div class="chat-input" *ngIf="chatWindow">
            <ng-container *ngIf="files.length; else chatInput">
                <button mat-icon-button type="button" class="option-button">
                    <mat-icon class="mat-icon-rtl-mirror" (click)="deselectFiles();">delete</mat-icon>
                </button>
                <div style="width: 100%;">
                    <b>{{files.length}} Files selected</b>
                </div>
                <button mat-icon-button type="button" class="send-button">
                    <mat-icon class="mat-icon-rtl-mirror" (click)="sendFiles();">upload</mat-icon>
                </button>
            </ng-container>
            <ng-template #chatInput>
                <button mat-icon-button type="button" class="option-button d-inline-flex">
                    <mat-icon class="mat-icon-rtl-mirror" (click)="fileUpload.click();">attach_file</mat-icon>
                </button>
                <input type="text" class="text-input" [placeholder]="'message'|translate" [formControl]="messageInput" (keyup.enter)="sendChatMessage();">
                <button mat-icon-button type="button" class="send-button d-inline-flex" (click)="sendChatMessage();">
                    <mat-icon class="mat-icon-rtl-mirror">send</mat-icon>
                </button>
            </ng-template>
        </div>
    </div>
</div>

<input type="file" class="d-none" (change)="onFileDropped($event)" multiple #fileUpload>

<ng-template #listEmpty>
    <div class="empty-state">
        <img class="illustration" src="assets/svg/empty_state.svg">
        <h3 class="text-secondary">No chat messages, yet.</h3>
    </div>
</ng-template>
